<template>
  <div>
    <headBox title="双录单"></headBox>
    <div class="tbd-content">
      <!-- 搜索部分 -->
      <topSearchForm @search="queryOrderList" :showSwtich="false" :hiddenExport="true">
        <el-form :inline="true" class="rform" :model="orderForm" ref="loginform">
          <el-form-item label="姓名" class="small1">
            <el-input v-model="orderForm.policyerName" placeholder="请输入投保人姓名" clearable class="only-input"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" class="small1">
            <el-input v-model="orderForm.productName" placeholder="请输入" clearable class="only-input"></el-input>
          </el-form-item>
          <el-form-item v-if="[1, 2].includes(userinfo.userLevel) && [1, 2].includes(userinfo.level * 1)">
            <div class="cell-border">
              <el-select class="left-select" v-model="orderForm.selectedLevel" @change="changeMechOrdep" placeholder="出单团队">
                <el-option label="出单团队" value="2"></el-option>
                <el-option label="出单员工" value="3"></el-option>
              </el-select>
              <el-select v-if="orderForm.selectedLevel == 2" class="right-select" v-model="orderForm.mechanId" clearable filterable>
                <el-option :label="dept.shortName" :value="dept.id" v-for="(dept, index) in selectList" :key="index"></el-option>
              </el-select>
              <el-select v-else-if="orderForm.selectedLevel == 3" class="right-select" v-model="orderForm.userId" clearable filterable>
                <el-option :label="dept.name" :value="dept.id" v-for="(dept, index) in userList" :key="index"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="出单员工" v-if="[3].includes(userinfo.userLevel) && [2].includes(userinfo.level * 1)">
            <el-select v-model="orderForm.userId" clearable filterable>
              <el-option :label="dept.name" :value="dept.id" v-for="(dept, index) in userList" :key="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="创建日期" class="small">
            <a-range-picker class="only-date-picker" v-model="orderForm.createTime" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD" separator="至">
              <i class="icon-riqixuanze" slot="suffixIcon"></i>
            </a-range-picker>
          </el-form-item>

          <el-form-item label="">
            <div class="cell-border">
              <el-select class="left-select" v-model="orderForm.orderClassify" placeholder="订单号">
                <el-option label="订单号" value="1"></el-option>
                <el-option label="保单号" value="2"></el-option>
              </el-select>
              <el-input class="right-input" type="text" v-model="orderForm.orderOrPolicyNo" placeholder="请输入" clearable></el-input>
            </div>
          </el-form-item>
        </el-form>
      </topSearchForm>

      <div class="order-detail">
        <el-tabs v-model="doubleRecordStatus" @tab-click="handlePaneClick">
          <el-tab-pane label="全部" name=" ">
            <double-recording-list v-loading="loading" :orderList="orderList" ref="child"></double-recording-list>
          </el-tab-pane>
          <el-tab-pane label="待双录" name="0">
            <double-recording-list v-loading="loading" :orderList="orderList" ref="child1"></double-recording-list>
          </el-tab-pane>
          <el-tab-pane label="待补录" name="-2">
            <double-recording-list v-loading="loading" :orderList="orderList" ref="child1"></double-recording-list>
          </el-tab-pane>
          <el-tab-pane label="审核中" name="1">
            <double-recording-list v-loading="loading" :orderList="orderList" ref="child2"></double-recording-list>
          </el-tab-pane>
          <el-tab-pane label="审核失败" name="-1">
            <double-recording-list v-loading="loading" :orderList="orderList" ref="child3"></double-recording-list>
          </el-tab-pane>
          <el-tab-pane label="审核通过" name="2">
            <double-recording-list v-loading="loading" :orderList="orderList" ref="child4"></double-recording-list>
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-pagination
        background
        v-if="pageFlag"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="allData.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="allData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allData.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
//当前实例组件
import topSearchForm from '@/components/topSearchForm.vue';
import headBox from "@/components/head.vue";
import doubleRecordingList from './components/double_recording_list';
import { common } from "@/api/mixins";

export default {
  mixins: [common],
  data: () => ({
    secondNavTabs: '0',
    navTabs: '0',
    pageFlag: false,
    loading: true,
    pageNum: 1,
    pageSize: 10,
    allData: '', // 订单列表所有数据
    orderList: [], // 订单列表
    doubleRecordStatus: ' ',
    params: {}, // 参数对象
    userList: [],
    selectList: [], // 出单团队出单员工的内容列表
    userinfo: {},
    orderForm: {
      policyerName: '',//投保人姓名
      productName: '', // 产品名称
      mechanName: '', // 团队简称
      nameOrPh: '', // 姓名或者手机
      orderStatus: '1', // 订单状态
      mechanId: '', // 出单团队/员工id
      userId: '',
      selectedLevel: '2',// 2出单团队，3出单员工，如果是一级团队默认2，二级团队默认3
      createTime: [], // 创建日期
      orderClassify: '1',//1订单号，2保单号
      orderOrPolicyNo: '', // 订单号或者保单号
    },
    nav: [
      {
        active: true,
        status_desc: '全部',
        value: '-1',
      },
      {
        active: false,
        status_desc: '未生效',
        value: '1',
      },
      {
        active: false,
        status_desc: '已生效未过犹',
        value: '2',
      },
      {
        active: false,
        status_desc: '已过犹',
        value: '3',
      },
      {
        active: false,
        status_desc: '部分退款',
        value: '4',
      },
    ]
  }),
  created() {
    let begin = new Date();
    let end = new Date();
    begin = begin.getTime() - 29 * 24 * 3600 * 1000
    let timeArr = []
    timeArr[0] = this.$tools.formatDate(begin)
    timeArr[1] = this.$tools.formatDate(end)
    this.orderForm.createTime = timeArr
    this.getUserInfo()
  },
  mounted() {
    this.getOrderList() // 获取订单列表
  },
  methods: {
    getUserList() {
      this.$http({
        url: '/master/subAccount/queryUsersList',
        type: 'PUT',
        params: {}
      })
        .then(res => {
          if (res.httpCode == 200) {
            this.userList = res.data;
          }
        })
        .catch(e => { });
    },
    getUserInfo() {
      const data = this.$tools.getLocal('userinfo')
      this.userinfo = this.$tools.getLocal("userinfo");

      if (data.userLevel == 1 || (data.level == 2 && data.userLevel == 2)) {
        // 一级团队默认出单团队
        this.orderForm.selectedLevel = '2'
        this.getChildList()// 获取出单团队列表
        this.getUserList()
      } else if (data.level == 2) {
        //二级团队没有出单团队，默认出单员工
        this.orderForm.selectedLevel = '3'
        this.getUserList()
      }
    },
    // 处理为空的children，el-cascader为空的数组会展示暂无数据
    handleDeptTree(data) {
      let val = data.map(item => {
        if (item.children.length == 0) {
          item.children = ''
        } else {
          this.handleDeptTree(item.children)
        }
        return item
      })
      return val
    },
    // 获取团队/员工列表
    getChildList() {
      this.$http({
        url: '/master/mechan/queryChildList',
        type: 'PUT',
        params: {
          includeFirst: '1'
        },
      }).then(res => {
        if (res.httpCode == 200) {
          this.selectList = res.data
        }
      })
    },
    // 查询
    queryOrderList() {
      this.pageNum = 1
      this.getOrderList()
    },
    // 团队/员工下拉切换
    changeMechOrdep() {
      this.orderForm.mechanId = '';
      this.orderForm.userId = '';
      this.getChildList();
    },
    // panel切换事件
    handlePaneClick(tab) {
      this.doubleRecordStatus = tab.name

      //每次分页都查询第一页
      this.pageNum = 1
      this.getOrderList()
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getOrderList()
    },

    handleCurrentChange(val) {
      this.pageNum = val
      this.getOrderList()
    },

    handleParams() {
      this.params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        doubleRecordStatus: this.doubleRecordStatus,
        policyerName: this.orderForm.policyerName,
        productName: this.orderForm.productName,
        mechanId: this.orderForm.mechanId,
        userId: this.orderForm.userId,
        createTimeStart: this.orderForm.createTime[0],
        createTimeEnd: this.orderForm.createTime[1],
        orderNo: this.orderForm.orderClassify == 1 ? this.orderForm.orderOrPolicyNo : '',
        policyNo: this.orderForm.orderClassify == 2 ? this.orderForm.orderOrPolicyNo : ''
      }
      for (var key in this.params) {
        if (this.params[key] === '') {
          delete this.params[key]
        }
      }
    },
    // 订单列表
    getOrderList() {
      this.loading = true
      this.handleParams()
      this.$http({
        url: '/master/order/doubleRecord/list',
        type: 'put',
        params: this.params,
      }).then((res) => {
        console.log(res, "-----")
        this.loading = false
        this.pageFlag = false
        this.allData = res
        if (this.allData.total != 0) {
          this.pageFlag = true
        }
        this.orderList = res.data;

        //订单服务费处理
        this.orderList.map((item, index) => {
          if (item.productItems) {
            item.incomes = item.productItems.reduce((pre, cur) => {
              return parseFloat(pre) + parseFloat(cur.incomes)
            }, 0)
            item.incomes = item.incomes.toFixed(2)
          }
        })
      })
    },
    // nav切换
    navStatusChange(index) {
      if (this.userinfo.level == 1) {
        for (var item of this.nav) {
          item.active = false
        }
        this.nav[index].active = true
      }
      this.getOrderList()
    },
  },
  components: {
    doubleRecordingList,
    headBox,
    topSearchForm
  },
}
</script>
<style lang="scss" scoped>
@import './order_double_recording';
</style>